import { createSelector, createSlice } from '@reduxjs/toolkit';

const attendanceSlice = createSlice({
    name: 'attendance',
    initialState: {
        isLoading: false,
        todayLoading: false,
        attendance: [],
        todaysAttendance: null
    },
    reducers: {
        createAttendance: (state, action) => {
            state.todayLoading = true;
        },
        closeAttendance: (state) => {
            state.todayLoading = true;
        },
        createBreak: (state) => {
            state.todayLoading = true;
        },
        closeBreak: (state) => {
            state.todayLoading = true;
        },
        listMyAttendance: (state) => {
            state.isLoading = true
        },
        todayAttendance: (state) => {
            state.todayLoading = true;
        },
        updateAttendanceTime:(state)=>{
            state.isLoading=true;
        },
    
        updateBreakTime:(state)=>{
            state.isLoading=true;
        },
    
        storeTodayAttendance: (state, action) => {
            const tAttn = action.payload;
            if (tAttn) {
                const uList = state.attendance.find(d => d?._id === tAttn._id)
                if (!uList) {
                    state.attendance.push(tAttn);
                } else {
                    const nList = state.attendance.map(d => d?._id === tAttn._id ? tAttn : d);
                    state.attendance = nList;
                }
            }
            state.todaysAttendance = tAttn;
            state.todayLoading = false;
        },
        updateAttendanceList: (state, action) => {
            state.attendance = action.payload;
            state.isLoading = false;
        },
        storeMyAttendanceList: (state, action) => {
            state.attendance = action.payload;
            state.isLoading = false;
        },
        resetAttendanceLoading: (state) => {
            state.isLoading = false;
            state.todayLoading = false;
        },
        generateMonthlyReport: () => { },
        clearAllAttendanceData: (state) => {
            state.isLoading = false;
            state.todayLoading = false;
            state.attendance = [];
            state.todaysAttendance = {};
        }
    },
});

export const {
    clearAllAttendanceData,
    createAttendance,
    closeAttendance,
    createBreak,
    closeBreak,
    storeMyAttendanceList,
    storeTodayAttendance,
    todayAttendance,
    listMyAttendance,
    updateAttendanceList,
    updateBreakTime,
    generateMonthlyReport,

    updateAttendanceTime,
    resetAttendanceLoading
} = attendanceSlice.actions;


// export const attendanceListSelector = state => state.attendance.attendance;
// export const todayAttendanceSelector = state => state.attendance.todaysAttendance;
// export const attendanceLoadingSelector = state => {
//     const isLoading = state.attendance.isLoading;
//     const todayLoading = state.attendance.todayLoading;
//     return { isLoading, todayLoading }
// }

export const attendanceListSelector = createSelector(
    state => state.attendance,
    attendance => attendance.attendance
);

export const todayAttendanceSelector = createSelector(
    state => state.attendance,
    attendance => attendance.todaysAttendance
);

export const attendanceLoadingSelector = createSelector(
    state => state.attendance.isLoading,
    state => state.attendance.todayLoading,
    (isLoading, todayLoading) => ({ isLoading, todayLoading })
);

export default attendanceSlice.reducer;
